import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { getLocalizedCaptionToneHint } from '../../captionLocalization';
import { getLocalParticipant } from '../../../base/participants/functions';
import { getLargeVideoParticipant } from '../../../large-video/functions';
import { isLayoutTileView } from '../../../video-layout/functions.web';
import { AbstractCaptions, _abstractMapStateToProps } from '../AbstractCaptions';
import { getActiveCaptionSurface, getCaptionSizeClassName } from '../../captionPreferences';
import { getCaptionTonePresentation } from '../../captionTone';
/**
 * React {@code Component} which can display speech-to-text results from
 * Jigasi as subtitles.
 */
export class Captions extends AbstractCaptions {
    /**
     * Renders the transcription text.
     *
     * @param {string} id - The ID of the transcript message from which the
     * {@code text} has been created.
     * @param {Object} transcript - Subtitles text and optional tone metadata.
     * @protected
     * @returns {ReactElement} - The React element which displays the text.
     */
    _renderParagraph(id, transcript) {
        const { _captionPreferences } = this.props;
        const presentation = getCaptionTonePresentation(transcript.tone, {
            mode: _captionPreferences.expressiveMode,
            motionEnabled: _captionPreferences.toneMotion,
            surface: getActiveCaptionSurface('malkaVrsCc'),
            toneMarkerLane: _captionPreferences.expressiveMode !== 'minimal'
                && _captionPreferences.toneMarkerLane
        });
        const showMarkerLane = Boolean(presentation.symbols.length);
        const hint = getLocalizedCaptionToneHint(presentation, this.props.t);
        return (React.createElement("p", { key: id },
            showMarkerLane ? (React.createElement("span", { "aria-hidden": 'true', className: 'caption-tone__marker-lane' }, presentation.symbols.join(' '))) : null,
            _captionPreferences.screenReaderToneHints && hint ? (React.createElement("span", { className: 'caption-tone__screen-reader-hint' }, hint)) : null,
            React.createElement("span", { className: presentation.className, dir: 'auto', style: presentation.style }, transcript.text)));
    }
    /**
     * Renders the subtitles container.
     *
     * @param {Array<ReactElement>} paragraphs - An array of elements created
     * for each subtitle using the {@link _renderParagraph} method.
     * @protected
     * @returns {ReactElement} - The subtitles container.
     */
    _renderSubtitlesContainer(paragraphs) {
        const { _captionPreferences } = this.props;
        const presentation = getCaptionTonePresentation(undefined, {
            mode: _captionPreferences.expressiveMode,
            motionEnabled: _captionPreferences.toneMotion,
            surface: getActiveCaptionSurface('malkaVrsCc')
        });
        const className = this.props._isLifted
            ? 'transcription-subtitles lifted'
            : 'transcription-subtitles';
        return (React.createElement("div", { className: `${className} ${presentation.modeClassName} ${getCaptionSizeClassName(_captionPreferences.captionSize)} ${presentation.motionClassName}` }, paragraphs));
    }
}
/**
 * Maps (parts of) the redux state to the associated {@code }'s
 * props.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const isTileView = isLayoutTileView(state);
    const largeVideoParticipant = getLargeVideoParticipant(state);
    const localParticipant = getLocalParticipant(state);
    return {
        ..._abstractMapStateToProps(state, ownProps),
        _isLifted: Boolean(largeVideoParticipant && largeVideoParticipant?.id !== localParticipant?.id && !isTileView)
    };
}
export default translate(connect(mapStateToProps)(Captions));
